// extracted by mini-css-extract-plugin
module.exports = {"iframe":"preview_iframe__3gpQR","Prev_tab":"preview_Prev_tab__3_NpN","ant-tabs-bar":"preview_ant-tabs-bar__B5bmG"};